export const ORANGE = '#FF9500'
export const GRAY = '#505050'
export const LIGHTGRAY = '#D4D4D2'